var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.64649 2.1464C7.84174 1.9512 8.15826 1.9512 8.35351 2.1464L10.9785 4.77071C11.1738 4.96595 11.1738 5.28253 10.9786 5.47782C10.7834 5.67311 10.4668 5.67315 10.2715 5.47791L8.5 3.70688V9.49999C8.5 9.77613 8.27614 9.99999 8 9.99999C7.72386 9.99999 7.5 9.77613 7.5 9.49999V3.70688L5.72851 5.47791C5.53322 5.67315 5.21664 5.67311 5.0214 5.47782C4.82616 5.28253 4.82621 4.96595 5.02149 4.77071L7.64649 2.1464Z",
    fill: "#22264C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 9.5C3 9.22386 2.77614 9 2.5 9C2.22386 9 2 9.22386 2 9.5V13C2 13.2652 2.10536 13.5196 2.29289 13.7071C2.48043 13.8946 2.73478 14 3 14H13C13.2652 14 13.5196 13.8946 13.7071 13.7071C13.8946 13.5196 14 13.2652 14 13V9.5C14 9.22386 13.7761 9 13.5 9C13.2239 9 13 9.22386 13 9.5V13H3V9.5Z",
    fill: "#22264C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/UploadIcon.b170ec0d.svg";
export { ForwardRef as ReactComponent };